export enum EWithdrawOwner {    
    Shipper
}